<template>
  <v-chart
    :option="chartOptions"
    style="width: 600px; height: 400px;"
  ></v-chart>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  data() {
    return {
      chartOptions: {
        series: {
          type: "graph",
          layout: "force",
          data: [
            { name: "Node 1" },
            { name: "Node 2" },
            { name: "Node 3" },
            { name: "Node 4" }
          ],
          links: [
            { source: "Node 1", target: "Node 2" },
            { source: "Node 2", target: "Node 3" },
            { source: "Node 3", target: "Node 4" },
            { source: "Node 4", target: "Node 1" }
          ],
          roam: true
        }
      }
    };
  }
};
</script>
